import script from "./webSocketPage.vue?vue&type=script&setup=true&lang=js"
export * from "./webSocketPage.vue?vue&type=script&setup=true&lang=js"

import "./webSocketPage.vue?vue&type=style&index=0&id=347c6209&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-347c6209"]])

export default __exports__